import { GAEvent } from './events';
import { createUndefinedObject, pushDataLayer } from './utils';

export const trackWeeklySurveyCompleted = async () => {};

interface SurveyData {
  date: string;
  surveyQuestion: string;
  surveyAnswer: string;
  surveyAnswerFeedback?: string;
}

export const trackSurvey = async (data: SurveyData) => {
  pushDataLayer<SurveyData>(GAEvent.WEEKLY_SURVEY_COMPLETED, data);
};

export const clearSurveyDataLayer = () => {
  const surveyDataUndefined = createUndefinedObject<SurveyData>();
  pushDataLayer(`clear_${GAEvent.WEEKLY_SURVEY_COMPLETED}`, surveyDataUndefined);
};
